/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BillUpdate = {
    properties: {
        billingCycleId: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        pastDueAmount: {
            type: 'number',
            isNullable: true,
            format: 'double',
        },
        dueAmount: {
            type: 'number',
            isNullable: true,
            format: 'double',
        },
        meterUsages: {
            type: 'MeterUsages',
        },
        attachedFilename: {
            type: 'string',
            isNullable: true,
        },
        attachedFileEncodedData: {
            type: 'string',
            isNullable: true,
        },
    },
};